export default "__VITE_ASSET__CaaAnntn__"